let baseUrl = window._env_.VUE_APP_API_BASEURL;
// if (window._env_.NODE_ENV !== 'pro') {
//   // 测试 生产
//   baseUrl = 'https://web-e-gw.ruijie.com.cn/api/market-activity';
// }
export default baseUrl;
